import { useQuery } from '@tanstack/react-query';
import { api, apiUrls } from '@/lib/apiClient';
import type { FundModel } from '@/types/model.types';

/**
 * Replaces DataService.getAllFunds. The hand-rolled `allFunds$` memoization and
 * `clearActivities()` invalidation are handled by the query cache; sign-out
 * clears it (see AuthEvents.tsx).
 */
export function useFunds() {
  return useQuery({
    queryKey: ['funds'],
    queryFn: () => api.get<FundModel[]>(apiUrls.fund, { operation: 'retrieving funds' }),
    staleTime: 5 * 60_000, // fund list barely changes within a session
  });
}
